export const APP_NAME = "AffiliZone";
export const APP_COMPANY_NAME = "AffiliZone Limited";
export const BASE_URL = process.env.VUE_APP_BASE_URL;
export const API_URL = process.env.VUE_APP_API_URL; // "http://ojaa.local/api";
export const APP_DESCRIPTION = process.env.VUE_APP_DESCRIPTION;

export const APP_LINKS = {
  about: "#",
  privacy: "#",
  contact: "#"
};

// export const HAS_LOGIN_BG = false;
export const APP_CONFIG = {
  has_login_bg: true,
  login_bg: "assets/media/bg/bg-3.jpg",
  app_logo: "assets/affilihub.png",
  login_bgs: {
    default: "assets/media/bg/app-bg-1.jpg",
    admin: "assets/media/bg/app-bg-4.jpg",
    affiliate: "assets/media/bg/app-bg-2.jpg",
    vendors: "assets/media/bg/app-bg-3.jpg"
  }
};

export default {
  APP_NAME,
  APP_COMPANY_NAME,
  BASE_URL,
  API_URL,
  APP_CONFIG,
  APP_DESCRIPTION
};
